import React from 'react';
import ShareButton from './ShareButton';

export default class SectionHeader extends React.Component {
  render() {
    let className = 'section-header';
    let innerClassName = 'section-header-inner'
    let overlayClassName = 'section-header-overlay'
    if (!this.props.bg) {
      className += ' bg-connectwork';
    } else {
      className += ' bg-' + this.props.bg;
    }
    return (
      <div className={className}>
        <div className={overlayClassName}>
          <div className={innerClassName}>
            <ShareButton slug={this.props.slug} />
            {this.props.name && <h1 dangerouslySetInnerHTML={{ __html: this.props.name}} />}
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}
